import type { Breakpoint } from '../types'

/**
 * Breakpoint pixel values matching Tailwind defaults
 */
export const BREAKPOINT_VALUES = {
  '2xl': 1536,
  lg: 1024,
  md: 768,
  sm: 640,
  xl: 1280,
} satisfies Record<Breakpoint, number>
